import { type CountryCode, currencyForCountry } from '@noconflict/contracts';
import { useTranslation } from 'react-i18next';

/**
 * Helper text under every country field that creates an organization (Q16): the country sets the billing
 * currency, and the sentence names the currency as soon as a country is chosen.
 */
export function BillingCurrencyNotice({ country }: { country: CountryCode | undefined }) {
  const { t } = useTranslation('org');
  return (
    <>
      {t('currencyNotice.rule')}
      {country ? ` ${t('currencyNotice.chosen', { currency: currencyForCountry(country) })}` : null}
    </>
  );
}
